type DiskSpaceStatus = 'normal' | 'warning' | 'alert';

interface IUnitSpace {
  maxGb: number;
  maxTb: number;
  currentUsedGb: number;
  leftGb: number;
  usedPercentage: number;
  leftPercentage: number;
  currentStatus: DiskSpaceStatus;
  estimatedRemainedDays: number;
}

export class DiskSpace implements IUnitSpace {
  constructor(currentUsedGb: number, maxGb: number, totalDays: number) {
    this._caculateSpace(totalDays, currentUsedGb, maxGb);
  }

  private baseSpaceGb = 1000;

  maxGb: number;
  maxTb: number;
  currentUsedGb: number;
  leftGb: number;
  usedPercentage: number;
  leftPercentage: number;
  estimatedRemainedDays: number;

  warningUsagePercentage = 70;
  alertUsagePercentage = 85;

  get currentStatus(): DiskSpaceStatus {
    if (this.usedPercentage >= this.alertUsagePercentage) {
      return 'alert';
    } else if (this.usedPercentage >= this.warningUsagePercentage) {
      return 'warning';
    }

    return 'normal';
  }

  static formatSpaceNumber(num: number) {
    return +num.toFixed(2);
  }

  /**
   * 計算容量 (單位 GB)
   */
  private _caculateSpace(totalDays: number, currentUsedGb: number, maxGb = 1000) {
    const max = maxGb;
    const current = currentUsedGb;
    const usedPercentage = DiskSpace.formatSpaceNumber((current / max) * 100);

    this.currentUsedGb = currentUsedGb;
    this.maxGb = maxGb;
    this.maxTb = DiskSpace.formatSpaceNumber(maxGb / this.baseSpaceGb);
    this.leftGb = DiskSpace.formatSpaceNumber(Math.max(maxGb - currentUsedGb, 0));
    this.usedPercentage = usedPercentage;
    this.leftPercentage = DiskSpace.formatSpaceNumber(Math.max(100 - usedPercentage, 0));
    
    // 計算預估剩餘天數
    const gbPerDay = totalDays === 0 ? 0 : currentUsedGb / totalDays;
    this.estimatedRemainedDays = gbPerDay === 0 ? 0 : DiskSpace.formatSpaceNumber((maxGb - currentUsedGb) / gbPerDay);
  }
}
